module.exports = __webpack_public_path__ + "static/media/Potato.573537ec.webp";